import styled from "styled-components";

export const Page = styled.div`
  height: 100%;
`;
